// Resize a user-picked image client-side so we don't blow past the
// backend's 4 MB upload limit on phone photos (often 3-6 MB straight
// from a camera). Returns a Blob suitable for upload.
//
// Strategy: scale longest edge to maxDim, output JPEG at quality 0.85.
// Almost any real-world food photo lands well under 1 MB after this.
export async function resizeImage(file, maxDim = 1600) {
  if (!/^image\//.test(file.type)) return file;
  // Small enough → leave it alone (preserves PNG transparency etc.)
  if (file.size <= 1.2 * 1024 * 1024) return file;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Could not read file."));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Could not decode image."));
      img.onload = () => {
        const ratio = Math.min(1, maxDim / Math.max(img.width, img.height));
        const w = Math.round(img.width * ratio);
        const h = Math.round(img.height * ratio);
        const canvas = document.createElement("canvas");
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        canvas.toBlob(
          (blob) => {
            if (!blob) return reject(new Error("Could not encode image."));
            // Re-wrap as File so the upload sees a sensible filename
            const out = new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", {
              type: "image/jpeg",
            });
            resolve(out);
          },
          "image/jpeg",
          0.85,
        );
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
